import { render, staticRenderFns } from "./envioMensagensEstabelecimento.vue?vue&type=template&id=3e198bd5&scoped=true&"
import script from "./envioMensagensEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./envioMensagensEstabelecimento.vue?vue&type=script&lang=js&"
import style0 from "./envioMensagensEstabelecimento.vue?vue&type=style&index=0&id=3e198bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e198bd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VFlex,VForm,VLayout,VTextField})
